import React from 'react';
export const Button = ({
  children,
  variant = 'primary',
  className = '',
  ...props
}: any) => {
  const baseStyle = 'inline-flex items-center justify-center px-5 py-2.5 text-sm font-medium rounded-lg transition-all duration-200';
  const variants = {
    primary: 'bg-zano-pink text-white hover:bg-zano-pinkDark shadow-sm',
    secondary: 'bg-white text-zano-pink border border-zano-pink/60 hover:border-zano-pink hover:bg-zano-blush shadow-sm',
    dark: 'bg-zano-charcoal text-white hover:bg-black shadow-sm',
    accent: 'bg-zano-pink text-white hover:bg-zano-pinkDark shadow-sm',
    ghost: 'text-gray-600 hover:text-zano-charcoal hover:bg-gray-100'
  };
  return <button className={`${baseStyle} ${variants[variant as keyof typeof variants]} ${className}`} {...props} data-id="element-2422" data-mp="1jhjko97tjy5x">
      {children}
    </button>;
};